<div class="lay-wrapper lay-wrapper--90">
  <app-welcome-banner [header]="'generic.main.helloAdmin' | translate" [title]="'generic.main.adminHelloText'" />
  <div class="widget-container flex-row">
    <div class="widget-right-container flex-1">
      <app-admin-sidebar />
    </div>
    <div class="widget-left-container flex-5">
      <app-admin-toolbar />
      <app-admin-elements class="flex-1" />
    </div>
  </div>
</div>
